import type { IconData } from '@stacksjs/iconify-core'

export const moustache: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M24 14.074C23.052 12.186 21.268 11 18 11c-5.367 0-6.687 4.285-7.967 8.442c-1.159 3.76-2.285 7.417-6.348 7.696c-.855.059-1.485.994-.977 1.683C5.582 32.719 9.397 35 15 35c4.48 0 7.534-4.273 9-8.894C25.466 30.726 28.521 35 33 35c5.603 0 9.418-2.28 12.292-6.18c.508-.688-.122-1.623-.977-1.682c-4.063-.28-5.189-3.935-6.347-7.696C36.688 15.285 35.368 11 30 11c-3.267 0-5.052 1.186-6 3.074\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default moustache
